var map = {
	"./t1.png": "IQ7t",
	"./t1_h.png": "XvQl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fG/B";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab ^\.\/t1.*\.png$
// module id = fG/B
// module chunks = 1